import { AlertTriangle } from "lucide-react";

export default function ResponsibleBanner({ compact = false }) {
  return (
    <div
      className={`panel border-smasher-orange/25 ${compact ? "p-4" : "p-5"} flex items-start gap-3`}
      data-testid="responsible-banner"
    >
      <div className="w-9 h-9 rounded-lg bg-smasher-orange/15 flex items-center justify-center shrink-0">
        <AlertTriangle className="w-5 h-5 text-smasher-orange" />
      </div>
      <div className="text-xs text-slate-400 leading-relaxed">
        <span className="font-bold text-slate-200">21+ · Responsible Wagering.</span> Sports betting involves risk.
        No strategy guarantees a winning wager. Only wager money you can afford to lose and comply with the laws
        where you live. Sportsbook Smasher provides education and information — not financial advice or guaranteed
        outcomes. If you or someone you know has a gambling problem, call{" "}
        <a href="tel:1-800-426-2537" className="text-smasher-gold font-bold">1-800-GAMBLER</a>.
      </div>
    </div>
  );
}
